export default __webpack_public_path__ + "static/media/Geneva-Bold-Italic.bff700b5.ttf";